import {GetLoadables} from './loader'

// #if process.env.UIX_CHUNKED === 'true'
let loader = () => {
  return import(/* webpackChunkName: 'markdown' */ './markdownLoad')
}
const L = GetLoadables(loader, ['Markdown'])
// #endif

// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './markdownLoad'
// #endif

export let {Markdown} = L
